"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.API_GROUP_INSTANCE_MADE_PUBLIC = exports.API_GROUP_INSTANCE_MADE_PRIVATE = void 0;
var _events = require("@mulesoft/exchange-ui-portals-common/lib/analytics/events");
var API_GROUP_INSTANCE_MADE_PUBLIC = exports.API_GROUP_INSTANCE_MADE_PUBLIC = {
  name: 'API Group instance made public',
  required: _events.basicAssetProperties
};
var API_GROUP_INSTANCE_MADE_PRIVATE = exports.API_GROUP_INSTANCE_MADE_PRIVATE = {
  name: 'API Group instance made private',
  required: _events.basicAssetProperties
};
//# sourceMappingURL=events.js.map